import React from "react"

export function ChevronLeft() {
  return (
    <svg
      width="10px"
      height="19px"
      viewBox="0 0 10 19"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Desktop-+-Mobile"
        stroke="none"
        stroke-width="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="A07_Desktop-Search-Results"
          transform="translate(-41.000000, -284.000000)"
        >
          <rect fill="#FFFFFF" x="0" y="0" width="1366" height="1476" />
          <g
            id="Back"
            transform="translate(40.000000, 283.242641)"
            stroke="#000000"
          >
            <g id="Back/Black" transform="translate(0.242641, 0.514719)">
              <path
                d="M-0.5,5.5 L12,5.5"
                id="Stroke-1-Copy"
                transform="translate(5.500000, 5.500000) rotate(-45.000000) translate(-5.500000, -5.500000) "
              />
              <path
                d="M-0.5,13.9852814 L12,13.9852814"
                id="Stroke-1-Copy-2"
                transform="translate(5.500000, 13.985281) rotate(-315.000000) translate(-5.500000, -13.985281) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
